import { queryOptions, useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import voucherQueryKeys from './voucherQueryKeys'
import { getVoucherTypes } from '../service/voucherService'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'

export const useCtxVoucherTypes = () => {
  const companyId = useSelector(contextCompanyIdSelector)!
  return useQuery(
    queryOptions({
      queryKey: voucherQueryKeys.type({ companyId }),
      queryFn: getVoucherTypes,
      enabled: !!companyId,
      gcTime: 15 * 60 * 1000
    })
  )
}
